<template>
  <div>
    <!-- pc -->
    <div class="table_9">
      <div class="title">
        <span v-html="chnldesc">
          <!-- {{ cType }} -->
        </span>
        <a :href="docpuburl" v-html="news_doctitle" target="_blank">
          <!-- {{ cTitle }} -->
        </a>
      </div>
      <div class="table">
        <div class="img fl" v-show="img != ''">
          <a :href="docpuburl" target="_blank">
            <img :src="img" alt="" style="border-style: none" />
          </a>
        </div>
        <div class="content" v-html="news_doccontent">
          <!-- {{ cContent }} -->
        </div>
        <div class="info">
          <div class="department fl" style="margin-right: 5px">
            <a :href="docpuburl" v-html="docsourcename" target="_blank">
              <!-- {{ cDepartment }} -->
            </a>
          </div>

          <div class="date fl">
            <!-- {{ docpubtime | dataFormat2 }} -->
            {{ docpubtime.substring(0,10) }}
            <!-- {{ cDate }} -->
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="mobile">
      <div class="title">
        <span v-html="chnldesc">
          <!-- {{ cType }} -->
        </span>
        <a :href="docpuburl" v-html="news_doctitle" target="_blank">
          <!-- {{ cTitle }} -->
        </a>
      </div>
      <div class="table">
        <div class="img fl" v-show="img != ''">
          <a :href="docpuburl" target="_blank">
            <img :src="img" alt="" style="border-style: none" />
          </a>
        </div>
        <div class="content" v-html="news_doccontent">
          <!-- {{ cContent }} -->
        </div>
        <div class="info">
          <div class="department fl" style="margin-right: 5px">
            <a :href="docpuburl" v-html="docsourcename" target="_blank">
              <!-- {{ cDepartment }} -->
            </a>
          </div>

          <div class="date fl">
            <!-- {{ docpubtime | dataFormat2 }} -->
            {{ docpubtime.substring(0,10) }}
            <!-- {{ cDate }} -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-table-pic-hd",
  components: {},
  props: {
    cPicData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    // 类型
    chnldesc() {
      return this.cPicData.chnldesc;
    },
    // 图片
    img() {
      // return this.cPicData.thumbfiles;
      return this.cPicData.firstpic;
    },
    // 标题
    news_doctitle() {
      return this.cPicData.hd_doctitle;
    },
    // 内容
    news_doccontent() {
      return this.cPicData.hd_doccontent;
    },
    // 来源
    docsourcename() {
      return this.cPicData.sitedesc;
    },
    // 日期
    docpubtime() {
      return this.cPicData.docpubtime;
    },
    // 链接
    docpuburl() {
      return this.cPicData.docpuburl;
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang='less' scoped>
.fl {
  float: left;
}
.clear {
  clear: both;
}
a {
  text-decoration: none;
  color: rgb(1, 82, 147);
  margin-left: 5px;
}
@media screen and (min-width: 751px) {
  .mobile {
    display: none;
  }
  .table_9 {
    width: 823px;
    // height: 110px;
    margin-bottom: 40px;

    .title {
      width: 823px;
      height: 30px;

      margin-bottom: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgb(1, 82, 147);
      font-size: 18px;
      span {
        height: 20px;
        background-color: rgb(1, 82, 147);
        color: #ffffff;
        padding: 4px 10px 4px 10px;
      }
    }
    .table {
      width: 823px;
      height: 83px;
      .img {
        width: 140px;
        height: 83px;
        margin-right: 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .content {
        min-width: 560px;
        max-width: 823px;
        height: 48px;
        font-size: 16px;
        line-height: 26px;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .info {
        height: 40px;

        margin-top: 10px;
        color: rgb(169, 169, 169);

        a {
          margin: 0;
        }
        .department {
          a {
            color: rgb(169, 169, 169);
          }
          font-size: 16px;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  @w: 7.5vw;

  .table_9 {
    display: none;
  }
  .mobile {
    display: block;
    width: 730 / @w;
    height: 190 / @w;
    padding-left: 20 / @w;
    padding-bottom: 20 / @w;
    border-bottom: 15 / @w solid rgb(230, 230, 230);
    margin-bottom: 20 / @w;

    .title {
      width: 700 / @w;
      height: 50 / @w;
      line-height: 45 / @w;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgb(1, 82, 147);
      margin-bottom: 20 / @w;
      font-size: 18px;
      font-weight: bold;
      // font-size: 16 / @w;
      span {
        height: 20 / @w;
        background-color: rgb(1, 82, 147);
        color: #ffffff;
        padding: 4 / @w 10 / @w 4 / @w 10 / @w;
      }
    }
    .table {
      width: 700 / @w;
      height: 90 / @w;
      .img {
        width: 140 / @w;
        height: 123 / @w;
        margin-right: 20 / @w;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .content {
        min-width: 460 / @w;
        max-width: 700 / @w;
        height: 90 / @w;
        // font-size: 14 / @w;
        line-height: 45 / @w;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .info {
        a {
          margin: 0;
          color: rgb(169, 169, 169);
        }
        color: rgb(169, 169, 169);
        .department {
          font-size: 12px;
        }
        .date {
          font-size: 12px;
        }
      }
    }
  }
}
</style>